import React from "react";
import { Button, Stack, Typography } from "@mui/material";
import { PopupMessageWrapper } from "./PopupMessageWrapper";
import { useDataContext } from "../Context/useDataContext";
import CreateApi from "../Settings/appSettings";
import { useAuth } from "react-oidc-context";

interface GroupScorerConfirmationProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    preview?: boolean;
}

export const GroupScorerConfirmation = ({ open, setOpen, preview = false }: GroupScorerConfirmationProps) => {

    const api = CreateApi();
    const auth = useAuth();

    const { scoreData, scoreCode, currentRound, setScoreData, setGroupConfirmResult, setGroupScorer } = useDataContext();

    const handleConfirm = () => {
        if (preview) { setOpen(false); return; }

        const updatedScoreData = scoreData.map((score: any) => {
            const updatedRoundScores = score.roundScores.map((roundScore: any, index: number) => {
                if (index === currentRound - 1) {
                    return {
                        ...roundScore,
                        markerScoreCode: scoreCode
                    };
                }
                return roundScore;
            });
            return {
                ...score,
                groupScorer: true,
                roundScores: updatedRoundScores
            };
        });

        const response = api.post('/ls/UpdateGroupScorer', {
            eventScores: updatedScoreData.map((score: any) => ({_id: score._id})),
            roundIndex: currentRound - 1,
            markerScoreCode: scoreCode,
            userID: auth.user?.profile?.sub || `scoreCode:${scoreCode}`
        });

        setScoreData(updatedScoreData);   
        setOpen(false);
        setGroupConfirmResult(true);
        setGroupScorer(true);
    };

    const handleDecline = () => {
        setOpen(false);
        setGroupConfirmResult(true);
        setGroupScorer(false);
    };

    return (
        <PopupMessageWrapper open={open}>
            <Stack direction="column" spacing={2}>
                <Typography variant="h6" sx={{ color: 'sepia.dark', fontWeight: 700 }}>Group Scorer Confirmation</Typography>
                <Typography variant="body1" sx={{ color: 'sepia.main' }}>Are you going to score this group?</Typography>
                <Button variant="contained" onClick={handleConfirm} sx={{ backgroundColor: 'primary.light', color: 'white', '&:hover': { backgroundColor: 'primary.main' } }}>I will score</Button>
                <Button variant="contained" onClick={handleDecline} sx={{ backgroundColor: 'sepia.extraLight', color: 'sepia.dark', '&:hover': { backgroundColor: 'sepia.light', color: 'white' } }}>Naw, view only</Button>
            </Stack>
        </PopupMessageWrapper>
    );
};
